import { render, staticRenderFns } from "./avatar-image.vue?vue&type=template&id=227ec3b9&"
import script from "./avatar-image.js?vue&type=script&lang=js&"
export * from "./avatar-image.js?vue&type=script&lang=js&"
import style0 from "./avatar-image.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports